import React, { useState } from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";

const TermsModal = ({ isVisible, onDecline, onAccept, additionalNote }) => {
  const [webViewModalVisible, setWebViewModalVisible] = useState(false);
  const [url, setUrl] = useState("");

  const handlePress = (url) => {
    if (url) {
      setUrl(url);
      setWebViewModalVisible(true);
    }
  };

  const BulletItem = ({ number, text, url, color }) => (
    <div className="flex items-start space-x-2 text-sm">
      {number && <span className="font-semibold">{number}.</span>}
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`text-blue-500 underline ${color ? `text-${color}-500` : ""}`}
        >
          {text}
        </a>
      ) : (
        <span className={`text-gray-700 ${color ? `text-${color}-500` : ""}`}>{text}</span>
      )}
    </div>
  );

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onDecline}
      className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50"
    >
      <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-2/5 p-5">
        <div className="flex justify-between items-center border-b pb-2">
          <h2 className="text-lg font-semibold">Terms & Conditions</h2>
          <button onClick={onDecline} className="text-gray-600 hover:text-red-500">
            <FaTimes />
          </button>
        </div>
        
        <div className="mt-4 space-y-3 max-h-64 overflow-y-auto">
          <BulletItem number="1" text="Bookings are non-refundable and cannot be canceled." color="red" />
          {additionalNote?.length > 0 &&
            additionalNote.map((message, index) => (
              <BulletItem key={index} number={index + 2} text={message} />
            ))}
          <a
            href="#"
            onClick={() => handlePress("https://your-refund-policy-url.com")}
            className="text-blue-500 underline block text-sm mt-2"
          >
            Click here to know more.
          </a>
        </div>
        
        <div className="flex justify-end space-x-3 mt-5">
          <button
            onClick={onDecline}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onAccept}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            I Agree
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TermsModal;
